import React, { useState } from "react";
import { Link } from "react-router-dom";
import OrganisationSearchBar from "./OrganisationSearchBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function OrganisationSearchBarContainer(props) {
  const [searchFilter, setSearchFilter] = useState("");
  const [showResultsField, setShowResultsField] = useState(true);
  const searchCriterias = props.searchCriterias;

  let searchItems = [];

  if (!props.teacherInfo.isPending) {
    if (props.teacherInfo?.data?.programmes !== undefined) {
      props.teacherInfo.data.programmes.forEach((prog) => {
        if (searchCriterias.includes("programs")) {
          searchItems.push({
            label: prog.name,
            value: {
              name: prog.name,
              type: "program",
              url: "/teacher/programmeview/" + prog.id + "/" + prog.name,
              icon: "briefcase",
            },
          });
        }
        prog.classes.forEach((cl) => {
          if (searchCriterias.includes("classes")) {
            searchItems.push({
              label: cl.name,
              value: {
                name: cl.name,
                type: "class",
                url:
                  "/teacher/programmeview/" +
                  prog.id +
                  "/" +
                  prog.name +
                  "/classview/" +
                  cl.id +
                  "/" +
                  cl.name,
                icon: "users",
              },
            });
          }
          cl.students.forEach((stud) => {
            if (searchCriterias.includes("students")) {
              searchItems.push({
                label: stud.name,
                value: {
                  name: stud.name,
                  email: stud.email,
                  type: "student",
                  url:
                    "/teacher/programmeview/" +
                    prog.id +
                    "/" +
                    prog.name +
                    "/classview/" +
                    cl.id +
                    "/" +
                    cl.name +
                    "/studentview/" +
                    stud.id +
                    "/" +
                    stud.name,
                  icon: "user",
                },
              });
            }
          });
        });
      });
    }

    let resetSearch = (value) => {
      setShowResultsField(false);
      setSearchFilter(value);
    };

    let searchList = () => {
      let sortedSearchItems = searchItems.sort((a, b) =>
        a.value.name > b.value.name ? 1 : b.value.name > a.value.name ? -1 : 0
      );
      return sortedSearchItems
        .filter((item) => {
          if (searchFilter === "") {
            return null;
          } else if (
            item.value.name
              .toLowerCase()
              .includes(searchFilter.toLowerCase()) ||
            (item.value.email &&
              item.value.email
                .toLowerCase()
                .includes(searchFilter.toLowerCase()))
          ) {
            return item;
          } else {
            return null;
          }
        })
        .slice(0, 5)
        .map((item, i) => {
          return (
            <li className="search-bar--SearchItem" key={i}>
              <Link
                onClick={() => resetSearch(item.value.name)}
                to={item.value.url}
              >
                <FontAwesomeIcon
                  className="ms-2 me-2"
                  icon={item.value.icon}
                ></FontAwesomeIcon>
                {item.value.name}
              </Link>
            </li>
          );
        });
    };
    return (
      <OrganisationSearchBar
        setShowResultsField={setShowResultsField}
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
        showResultsField={showResultsField}
        searchList={searchList}
        placeHolder={props.placeHolder}
        theme={props.theme}
      />
    );
  }
  return null;
}
